module.exports = __webpack_public_path__ + "static/media/IMG_3508_sm.dd867013.jpg";